// i18n area 'cluster' — locale pt-PT (pt-PT, task #171, onda 1): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.pt-PT.meta.json.
import type { enUS } from './cluster'

export const ptPT: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Acessos de garantia',
      subtitle: 'A porta de serviço do nó: o acesso só de leitura com palavra-passe temporária e a conta de emergência com a palavra-passe do cofre',
      readOnlyTitle: 'Acesso só de leitura (trantor)',
      stateNone: 'fechado',
      stateGranted: 'aberto',
      stateGrantedPending: 'concedido — a ser aplicado no nó',
      grantedBy: 'Concedido por',
      grantedAt: 'Concedido em',
      expiresAt: 'Expira em',
      reason: 'Motivo',
      endedAt: 'Fechado',
      endedReason: {
        revoked: 'revogado',
        expired: 'expirado (TTL)',
        reboot: 'reinício do nó',
        failed: 'não aplicado (tarefa falhada)'
      },
      grant: 'Conceder acesso só de leitura…',
      grantTitle: 'Conceder acesso só de leitura',
      grantSubmit: 'Conceder',
      grantError: 'A concessão foi recusada',
      grantConfirm: 'O TVirt gera uma palavra-passe temporária para o utilizador de sistema «trantor» (só leitura: journal e diagnóstico, sem sudo) e define-a no nó com uma tarefa. A palavra-passe é mostrada UMA só vez, na confirmação; termina no prazo, na revogação ou no próximo reinício do nó.',
      reasonLabel: 'Motivo',
      reasonHint: 'Porque abres a porta: fica na concessão, na auditoria e no diário',
      ttlLabel: 'Duração',
      ttlHours: '{n} h',
      revoke: 'Revogar acesso só de leitura…',
      revokeTitle: 'Revogar acesso só de leitura',
      revokeSubmit: 'Revogar',
      revokeError: 'A revogação foi recusada',
      revokeConfirm: 'A concessão termina agora e uma tarefa volta a bloquear o utilizador «trantor» no nó: a palavra-passe temporária deixa de valer.',
      passwordTitle: 'Palavra-passe só de leitura',
      passwordOnce: 'Esta palavra-passe é mostrada UMA só vez: copia-a agora. Não é guardada em lado nenhum e não poderá ser lida de novo — se a perderes, concede outra vez.',
      passwordUser: 'Utilizador',
      passwordLabel: 'Palavra-passe',
      passwordHint: 'Válida até {until}, ou até ao próximo reinício do nó; utilizável quando a tarefa de concessão estiver concluída. Acesso: ssh trantor@<endereço do nó>.',
      emergencyTitle: 'Último acesso de emergência (trantor-emergency)',
      lastLogin: '{time} via {via} de {from}',
      lastLoginNone: 'nenhum observado',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'consola',
        sudo: 'sudo',
        unknown: 'desconhecido'
      },
      emergencyHint: 'A conta de emergência «trantor-emergency» (sudo completo) está sempre ativa com a palavra-passe gerada na instalação do nó e guardada no cofre: o TVirt não a conhece, não a roda nem a recupera. Cada início de sessão é reportado aqui e no diário de eventos.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall dos nós',
      subtitle: 'A postura do ruleset nftables que cada nó aplica a si próprio — o único firewall de um nó (o firewalld está desativado)',
      modeLabel: 'Postura',
      mode: {
        disabled: 'Desativado — nenhum ruleset nos nós',
        permissive: 'Permissivo — conta e regista, não descarta nada',
        enforced: 'Aplicado — só entra o registo derivado'
      },
      hint: {
        disabled: 'Como hoje: os nós não carregam nenhum ruleset. Passe a permissivo para LER o que seria descartado antes de o ser.',
        permissive: 'Cada nó aplica o seu ruleset derivado com policy accept: o que o modo aplicado descartaria é contado e registado (prefixo de journal «tvirt-node would-drop:»). Nada é bloqueado.',
        enforced: 'Cada nó aplica o seu ruleset derivado com policy drop: ssh e API de qualquer lado, store / live migration / overlay / Ceph só dos membros, os listeners dos serviços de rede a partir da rede servida. Cada mudança é um apply com confirmação — um nó que não consegue confirmar reverte sozinho.'
      },
      confirmTitle: 'Aplicar o firewall dos nós?',
      confirmBody: 'Cada nó aplica o ruleset com confirmação: sonda o backend, o store e o ssh através das novas regras dentro do prazo e confirma — caso contrário reverte sozinho para o ruleset anterior. Leia primeiro os contadores do modo permissivo nos nós.',
      confirmSubmit: 'Aplicar',
      confirmCancel: 'Cancelar',
      lensTitle: 'Firewall do nó',
      loadError: 'Não foi possível carregar a lente do firewall do nó',
      noReport: 'Ainda nenhum relatório de firewall deste nó — o worker reporta na próxima passagem',
      firewalldActive: 'Neste nó corre o firewalld: o firewall de nó recusa aplicar-se ao lado dele (mascare o firewalld)',
      conditionUnconfirmed: 'Ainda nenhum ruleset confirmado — o nó está aberto',
      conditionRolledBack: 'O último apply foi revertido — a mesma geração não é tentada de novo até o registo mudar ou a postura ser mudada outra vez',
      lastError: 'Último erro',
      posture: 'Postura',
      observedAt: 'Observado',
      desiredGeneration: 'Geração desejada',
      componentTitle: 'Componente de nó',
      componentSubtitle: 'tvirt-node-firewall — aplica no boot o ruleset confirmado, reverte sozinho um não confirmado',
      componentAbsent: 'O componente ainda não reportou',
      phase: 'Fase',
      phases: {
        none: 'Nunca aplicado',
        applied: 'Aplicado — à espera de confirmação',
        confirmed: 'Confirmado',
        rolledBack: 'Revertido'
      },
      generation: 'Geração',
      appliedAt: 'Aplicado em',
      confirmedAt: 'Confirmado em',
      deadline: 'Prazo do rollback',
      lastRollback: 'Último rollback',
      registryTitle: 'Registo derivado',
      registrySubtitle: 'As portas que este nó abre, por classe e origem — derivadas do cluster, nunca editadas à mão',
      registryEmpty: 'Nada derivado — postura desativada sem ruleset confirmado, ou ainda nenhum relatório',
      colClass: 'Classe',
      colPort: 'Porta',
      colSource: 'Fonte',
      colOrigin: 'Origem',
      classes: {
        public: 'Pública',
        internode: 'Inter-nó',
        tenant: 'Tenant'
      },
      sourceMembers: 'só os membros',
      sourceAnywhere: 'de qualquer lado',
      sourceBridge: 'em {iface}'
    },
    derivationDerived: 'derivado',
    derivationDiverged: 'divergente',
    derivationDerivedTip: 'O documento de rede é DERIVADO da fabric {fabric} e ainda coincide com o render sobre as entradas atuais — clique para o plano de derivação.',
    derivationDivergedTip: 'A derivação da fabric {fabric} mudou depois do último apply (fabric, cablagem, papéis ou referências) — clique para o diff pendente.',
    derivationRetiring: {
      one: '{n} endereço em drenagem',
      many: '{n} endereços em drenagem',
      other: '{n} endereços em drenagem'
    },
    standaloneHint: 'Este nó não tem cluster: ainda não foi instalado. Os clusters criam-se OU fazem join na instalação — o token gerado a partir da tabela Servidores de um membro entrega-se ao installer (dev: db:init-cluster / db:init-join).',
    reducedHint: 'As suas permissões cobrem um scope, não o cluster inteiro: o inventário da frota — nós, definições e dispositivos — só é visível para os administradores do cluster.',
    phaseReady: 'Pronto',
    phaseForming: 'Em formação',
    storeMembers: 'Membros do store',
    watermark: 'Limiar de convergência',
    configGeneration: 'Geração de config',
    converged: 'alinhado',
    behind: 'atrasado — {m} / {n}',
    revision: 'Revisão',
    rolesTitle: 'Papéis de rede',
    rolesSubtitle: 'Endereços por membro para cada classe de tráfego — a conectividade vive na rede do host',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'herda management',
    settingsTitle: 'Definições',
    settingsSubtitle: 'Política de segurança ao nível do cluster — avaliada por cada nó a partir da sua réplica local',
    taskRetentionTitle: 'Retenção de tasks',
    taskRetentionSubtitle: 'GC unificado para todas as tasks — as tasks concluídas além da idade ou do limite são recolhidas, nunca as que estão em curso',
    taskRetentionMaxAge: 'Idade máxima (dias)',
    taskRetentionMaxCount: 'Número máximo de tasks',
    eventRetentionTitle: 'Retenção de eventos',
    eventRetentionSubtitle: 'O GC do diário — uma política independente da das tarefas: a tarefa é uma fila, o evento é memória',
    eventRetentionMaxAge: 'Idade máxima (dias)',
    eventRetentionMaxCount: 'Número máximo de eventos',
    spaceThresholdsTitle: 'Limiares de espaço',
    spaceThresholdsSubtitle: 'Quando um armazenamento a encher entra no diário (e nas notificações)',
    spaceLowPct: 'Aviso a partir de (% usado)',
    spaceCriticalPct: 'Crítico a partir de (% usado)',
    spaceOrderError: 'O crítico não pode ficar abaixo do aviso',
    spaceThresholdsHint: 'Só as entradas se configuram: a saída é derivada pelo motor, 5 pontos abaixo de cada limiar, para que um armazenamento parado na linha nunca se torne um metrónomo',
    failoverReserveTitle: 'Reserva de failover',
    failoverReserveSubtitle: 'Admission control N+1 — RAM mantida livre para que o cluster possa reiniciar a sua carga após a perda de nós',
    failoverReserveTolerate: 'Perda de nós a tolerar',
    failoverReserveOff: '0 — reserva desligada: nenhum arranque é alguma vez recusado por capacidade de failover',
    failoverReserveOn: 'Um arranque que consumisse a reserva é recusado com um 412 que explica os números',
    networkShapingTitle: 'Equidade de largura de banda',
    networkShapingSubtitle: 'Os três pesos por tipologia da árvore de shaping por uplink — só atuam sob contenção',
    networkShapingRest: 'Peso do resto (plano de controlo, storage, réplicas)',
    networkShapingOverlay: 'Peso das redes overlay',
    networkShapingLiveMigration: 'Peso da live migration',
    networkShapingHint: 'Quota garantida = peso / soma dos três (por omissão 300 / 100 / 200, cada um de 1 a 10000); com a ligação livre cada classe pode ocupar toda a largura de banda',
    debugModeTitle: 'Modo debug',
    debugModeSubtitle:
      'Erros detalhados nos alertas genéricos da GUI — para ver a causa real quando uma ação «falhada» na verdade foi bem-sucedida',
    debugModeLabel: 'Modo debug ativado',
    debugModeOn: 'Os alertas de erro genéricos acrescentam a causa subjacente — detalhes internos visíveis para todos os operadores',
    debugModeOffHint: 'Desligado — os alertas de erro genéricos mantêm-se genéricos, sem detalhes internos',
    nodeDetailsAction: 'Detalhes do nó',
    node: {
      docTitle: 'Nó',
      notFound: 'Nó não encontrado',
      tabOverview: 'Visão geral',
      tabStats: 'Estatísticas',
      tabNetwork: 'Rede',
      tabSettings: 'Definições locais',
      identityTitle: 'Identidade',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Porta YSQL',
      revision: 'Revisão de config',
      versionsTitle: 'Versões observadas',
      heartbeatSubtitle: 'O último estado que o nó reportou sobre si próprio',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Modelo de CPU',
      memoryTitle: 'Memória',
      hugePagesTitle: 'Páginas enormes',
      hugePagesPool: '{size}: {free} livres de {total}',
      hugePagesNone: 'Sem reserva',
      hugePagesNoneHint: 'O nó não tem páginas enormes reservadas: as VM que as pedem não podem arrancar aqui. A reserva declara-se no nó, com os parâmetros hugepagesz e hugepages do kernel ou escrevendo nr_hugepages.',
      usageTitle: 'Utilização atual',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'não observado — nenhuma amostra fresca',
      statsNoData: 'Sem dados no intervalo — as séries do nó são amostradas pelo próprio nó e servidas localmente.',
      observedTitle: 'Estado observado',
      observedSubtitle: 'Serviços e assets locais ao nó, tal como o worker os vê'
    },
    editRolesTitle: 'Editar os papéis de rede',
    memberNode: 'Nó',
    memberIp: 'Endereço IP',
    addMember: 'Adicionar membro',
    lmInherit: 'Usar os endereços de management',
    roleIpHint: 'Adicionar e remover membros é livre; mudar no lugar o IP de um membro existente é recusado — o fluxo de migração de IP chega numa ronda posterior.',
    roleError: 'Não foi possível atualizar os papéis',
    nodesTitle: 'Nós',
    addNodeTitle: 'Adicionar nó ao cluster',
    addNode: 'Adicionar nó',
    addNodeError: 'Não foi possível pré-registar o nó',
    nodeName: 'Nome do nó',
    nodeNameHint: 'tem de coincidir com o nome escolhido na instalação',
    nodeIp: 'IP de management',
    colName: 'Nome',
    colPhase: 'Fase',
    colServices: 'Serviços',
    colWatermark: 'Watermark',
    colLastSeen: 'Último contacto',
    colUps: 'UPS',
    upsCordonChip: 'cordão UPS',
    upsCordonTip: 'O nó condenou-se pelos factos da sua UPS ({time}): liberta o cordão por si próprio quando a rede estabiliza e a bateria recarrega',
    upsUnreachable: 'UPS inacessível',
    upsOnBattery: 'Em bateria',
    upsOnLine: 'Na rede',
    upsLowBattery: 'bateria fraca',
    upsNoEstimateChip: 'autonomia não estimada',
    upsNoEstimateTip: 'A UPS não publica a estimativa de autonomia: o nó é condenado apenas pelo sinalizador LB (bateria fraca) da UPS — afine battery.runtime.low / LB na própria UPS',
    upsLaneTip: 'Via de encerramento UPS desde {since}: condenado por {by}',
    upsUnit: 'unidade',
    upsStatus: 'estado NUT',
    upsLoad: 'carga',
    upsOnBatterySince: 'em bateria desde',
    upsOnLineSince: 'na rede desde',
    upsError: 'erro',
    upsObservedAt: 'observado',
    upsNone: 'nenhuma unidade UPS serve este nó',
    upsBy: {
      runtime: 'autonomia abaixo do limiar',
      lowBattery: 'sinalizador LB da UPS',
    },
    upsLane: {
      evacuate: 'evacuação',
      local: 'encerramento no local',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'a parar convidados',
      stoppingServices: 'a parar serviços',
      poweredOff: 'desligado',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Unidades UPS e limiares: nó condenado com autonomia ≤ limiar ou sinalizador LB (sempre honrado), retoma com histerese',
    upsRuntimeThreshold: 'Limiar de autonomia (s)',
    upsRuntimeThresholdHint: 'Em bateria, com autonomia estimada ≤ limiar o nó encerra por ordem (predefinição 300)',
    upsResumeStable: 'Rede estável durante (s)',
    upsResumeStableHint: 'Retoma apenas com rede contínua há pelo menos tantos segundos (predefinição 60)',
    upsResumeCharge: 'Carga mínima na retoma (%)',
    upsResumeChargeHint: 'E bateria recarregada pelo menos a esta percentagem (predefinição 25)',
    upsPolicyNote: 'O sinalizador LB (bateria fraca) da UPS condena sempre e não se desativa; não existe limiar sobre o tempo em bateria. Cada unidade pode sobrepor os três números.',
    upsUnitNew: 'nova unidade',
    upsUnitSelectors: '{n} seletor(es) por etiqueta (só CLI)',
    upsUnitName: 'Nome da unidade',
    upsUnitMode: 'Modo',
    upsModeExternal: 'externa (upsd alheio)',
    upsModeManaged: 'gerida (UPS ligada a um nó)',
    upsUnitUpsname: 'Nome NUT (upsname)',
    upsUnitHost: 'Anfitrião upsd',
    upsUnitAttachedNode: 'Nó ligado',
    upsUnitDriver: 'Controlador NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Dispositivo do controlador',
    upsUnitDeviceHint: 'a linha port= de ups.conf: vazio = auto',
    upsUnitPort: 'Porta upsd',
    upsUnitServedNodes: 'Nós servidos',
    upsUnitServedNodesHint: 'nomes dos nós separados por vírgulas (os seletores por etiqueta passam pela CLI)',
    upsUnitOverrideHint: 'vazio = predefinição do cluster',
    upsUnitAdd: 'Adicionar unidade',
    unreachableSince: 'Inalcançável — último heartbeat {time}',
    overlaysChip: 'overlays',
    overlaysBehind: 'O dataplane overlay ainda não realizou a configuração overlay atual',
    overlaysError: 'A última passagem de reconciliação de overlay falhou: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'À espera de join',
      'joining': 'Em adesão',
      'member': 'Membro'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Mostrado só agora — copie-o já, nunca mais poderá ser lido',
    copy: 'Copiar',
    copied: 'Copiado',
    close: 'Fechar',
    revokeTitle: 'Revogar pré-registo',
    revoke: 'Revogar',
    revokeError: 'Não foi possível revogar o registo',
    promote: 'Promover a store member',
    demote: 'Remover o papel store-member',
    troubleshoot: 'Resolução de problemas',
    promoteTitle: 'Promover a store member',
    demoteTitle: 'Remover o papel store-member',
    promoteHint: 'O nó entra no quórum dos masters YugabyteDB. Uma verdadeira HA exige três store members.',
    demoteHint: 'O nó sai do quórum dos masters e para os seus serviços store.',
    storeError: 'A alteração de store-member foi recusada',
    attest: 'Atestar desligado…',
    attestTitle: 'Atestar nó desligado',
    attestSubmit: 'Atestar desligado',
    attestConfirm: 'Está a declarar este nó desligado, por sua conta e risco: atestar um nó na verdade vivo arrisca VMs em execução dupla. As suas tasks são falhadas e as authorities das suas VMs tornam-se transferíveis.',
    attestError: 'A atestação foi recusada',
    attestedChip: 'atestado desligado',
    maintenanceChip: 'manutenção',
    guestToolsChip: 'TVirt Guest Tools (asset ISO local ao nó)',
    maintenanceEnter: 'Ativar manutenção',
    maintenanceExit: 'Desativar manutenção',
    maintenanceEnterTitle: 'Ativar manutenção',
    maintenanceExitTitle: 'Desativar manutenção',
    maintenanceEnterSubmit: 'Ativar manutenção',
    maintenanceExitSubmit: 'Desativar manutenção',
    maintenanceEnterConfirm: 'O nó é acordoado e esvaziado: os serviços de rede e as instâncias App cuja authority detém são transferidos (as instâncias a frio: paradas e ceifadas aqui, recriadas no nó de destino — indisponibilidade), as VM ligadas são migradas a quente onde possível e paradas de forma ordenada caso contrário, as tarefas em curso terminam, o novo trabalho fica em espera e as VM paradas perdem a sua authority — o Proximity volta a colocá-las no próximo arranque. Nada volta sozinho no fim da manutenção.',
    maintenanceExitConfirm: 'O nó retoma o trabalho e o Proximity volta a considerá-lo para a colocação. As VMs só regressam quando forem arrancadas.',
    maintenanceError: 'O pedido de manutenção foi recusado',
    maintenancePlanTitle: 'Plano de evacuação',
    maintenancePlanLoading: 'A calcular o plano de evacuação…',
    maintenancePlanError: 'Não foi possível carregar o plano de evacuação — o drain migrará na mesma onde possível e parará o resto.',
    maintenancePlanEmpty: 'Nada a evacuar neste nó — nenhum serviço de rede ativo, nenhuma instância App pretendida em execução, nenhuma VM ligada.',
    maintenancePlanSummary: '{migrate} objetos vão migrar (VM, serviços de rede, instâncias App), {stop} vão parar ou ficar onde estão.',
    maintenancePlanReserve_ok: 'Reserva de failover após o esvaziamento: intacta — restam {headroom} GiB arrancáveis tolerando a perda de {n} nó(s).',
    maintenancePlanReserve_eroded: 'Reserva de failover após o esvaziamento: quase consumida — restam apenas {headroom} GiB dos {reserve} GiB mantidos livres para {n} falha(s) de nó.',
    maintenancePlanReserve_exhausted: 'Reserva de failover após o esvaziamento: ESGOTADA — faltam {headroom} GiB dos {reserve} GiB necessários para tolerar {n} falha(s) de nó. Enquanto este nó estiver fora, os novos arranques de VM serão recusados.',
    maintenancePlanReserve_unknown: 'Reserva de failover após o esvaziamento: não calculável — nenhum nó restante declarou a sua memória.',
    maintenancePlanReserveHugePages: 'Páginas enormes de {size} após o esvaziamento — livres: {free} de {capacity}, exigidas como reserva: {reserve}.',
    maintenancePlanActionMigrate: 'migra',
    maintenancePlanActionMigrateWarning: 'migra (regra soft violada)',
    maintenancePlanActionStop: 'para',
    maintenancePlanActionBlocked: 'bloqueada',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'serviço de rede',
    maintenancePlanKindApp: 'instância App',
    maintenancePlanColdMove: 'Movimento a frio: o pod é parado e ceifado aqui e recriado no nó de destino pelo seu worker — indisponibilidade até ao próximo pass do worker de destino.',
    caFingerprint: 'Fingerprint da CA do cluster',
    staleChip: 'desatualizado',
    troubleshootTitle: 'Resolução de problemas do store',
    restartStore: 'Reiniciar os serviços store',
    restartHint: 'Se o store estiver a portar-se mal, reinicie os seus serviços. Avançado — usar com cuidado.',
    restartQueued: 'Task de reinício em fila',
    restartError: 'Não foi possível reiniciar os serviços',
    svcActive: 'ativo',
    svcWanted: 'pretendido, não ativo',
    svcStopped: 'parado',
    noServices: 'Nenhum serviço reportado'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'O inventário de GPUs de todo o cluster agrupado por modelo — as placas observadas por nó, com os registos marcados e as suas tags',
    usbTitle: 'Recursos USB',
    usbSubtitle: 'O inventário USB de todo o cluster agrupado por modelo — os dispositivos observados por nó, com os registos de ambos os modelos (por dispositivo, por porta) e as suas tags',
    markedChip: '{n} utilizáveis pelo TVirt',
    orphanChipGpu: '{n} órfãs',
    orphanChipUsb: '{n} órfãos',
    colNode: 'Nó',
    colRegistration: 'Registo',
    noRegsHint: 'Nenhum registo — o dispositivo marca-se "utilizável pelo TVirt" no dialog do nó (Nós › nó › Definições).',
    colDevice: 'Dispositivo',
    colObserved: 'Observados',
    colRegs: 'Registos',
    regsNone: 'nenhum',
    colPci: 'Endereço PCIe',
    colIdentity: 'Identidade / porta',
    colClasses: 'Classes (tags)',
    colActions: 'Ações',
    manageOnNode: 'Gerir no nó {node} (a marcação vive no dialog do nó)',
    introTitle: 'O inventário de cluster dos dispositivos USB e PCIe utilizáveis pelo TVirt©.',
    introStep1: '1. Os nós descobrem sozinhos as suas GPUs e os dispositivos USB (censo no heartbeat).',
    introStep2: '2. Um dispositivo marca-se "utilizável pelo TVirt" no dialog do NÓ (Nós › nó › Definições) — a marcação liga-o ao vfio e regista-o aqui.',
    introStep3: '3. Aqui dão-se aos registos as suas CLASSES via tags (ex. gpu_class=compute): os requisitos das VMs pedirão uma classe, e o scheduler escolherá um nó com um dispositivo livre compatível.',
    colMode: 'Modo',
    colState: 'Estado',
    colNotes: 'Notas',
    colTags: 'Tags',
    modeDevice: 'por dispositivo',
    modePort: 'por porta',
    usable: 'utilizável',
    orphanGpu: 'órfã',
    orphanUsb: 'órfão',
    hubChip: 'hub',
    orphanPortsTitle: 'Registos por porta sem dispositivo ligado — volte a ligar um dispositivo ou desmarque-os no nó',
    gpusEmpty: 'Nenhuma GPU observada ainda em nenhum nó',
    usbEmpty: 'Nenhum dispositivo USB observado ainda em nenhum nó'
  },
  settings: {
    passwordMinLength: 'Comprimento mínimo da palavra-passe',
    sessionIdle: 'Timeout de inatividade da sessão (minutos)',
    lockoutThreshold: 'Bloqueio após tentativas falhadas',
    lockoutDuration: 'Duração do bloqueio (minutos)',
    keyboardLayout: 'Layout do teclado',
    keyboardLayoutHint: 'ex. it, en-us — vazio para o default do QEMU',
    syslogEndpoint: 'Endpoint syslog',
    syslogEndpointHint: 'host:porta — vazio para desativar o reencaminhamento',
    syslogTls: 'TLS',
    maxQueued: 'Máximo de tasks em fila',
    concurrency: 'Concorrência do worker',
    concurrencyHint: 'Aplicada a quente pelo worker',
    notesTitle: 'Notas',
    save: 'Guardar',
    saved: 'Definições guardadas',
    saveError: 'Não foi possível guardar as definições'
  },
  localSettings: {
    derivedChip: 'derivado',
    derivedTip: 'Este device é PROPRIEDADE da derivação da fabric (H2): o editor recusa tocá-lo — altere a fabric (ou a cablagem) e reaplique, ou retome-o aqui em baixo.',
    takeOwnership: 'Tomar posse',
    takeOwnershipTitle: 'Tomar posse (take-ownership)',
    takeOwnershipConfirm: '{name} sai do bloco fabric e volta a ser um device MANUAL governado por este editor. O nó fica divergente, e o próximo apply da derivação recusará nele (manualConflict) até que o renomeie ou remova — ou corrija a fabric.',
    nodeSettingsTitle: 'Definições do nó',
    nodeSettingsSubtitle: 'O que este nó aplica — fila de tasks, consola, reencaminhamento de logs — mais as suas tags e as notas',
    baseTitle: 'Reservas do host (TVirt Proximity)',
    baseSubtitle: 'CPU e RAM reservadas ao sistema operativo do host — os inputs da capacidade empírica com que o Proximity coloca as VMs',
    baseMemory: 'RAM de base (MiB)',
    baseMemoryHint: 'Total observado: {total} MiB. Utilizável para as VMs = total − base − RAM das VMs ligadas colocadas aqui.',
    baseMemoryHintNoTotal: 'Utilizável para as VMs = total observado − base − RAM das VMs ligadas colocadas aqui.',
    baseCpu: 'Cores de CPU de base',
    baseCpuHint: 'CPUs lógicos observados: {total}. Usados apenas como peso de ranking — o overcommit de vCPU é normal.',
    baseCpuHintNoTotal: 'Usados apenas como peso de ranking — o overcommit de vCPU é normal.',
    baseHint: 'A RAM é o gate rígido de admissão: uma VM que não caiba na RAM utilizável é recusada com um erro falante. Suba a base nos hosts que alojam membros do store ou daemons Ceph.',
    placementTitle: 'Posicionamento físico',
    placementSubtitle: 'Onde este servidor está fisicamente — declarado uma vez, sirva o que servir',
    placementHint: 'O posicionamento guia a hierarquia CRUSH de cada cluster Ceph com um OSD neste servidor: guardar uma alteração realinha os seus mapas via task (host → rack → … → root). As declarações parciais são legais — os níveis vazios simplesmente colapsam. Os nomes são partilhados por todo o mapa: dois servidores no mesmo rack declaram o mesmo nome de rack.',
    placementNameInvalid: 'Nome DNS-safe (minúsculas, dígitos, hífenes)',
    placementEmpty: 'Vazio = não declarado',
    placementLevel: {
      chassis: 'Chassis',
      rack: 'Rack',
      row: 'Fila',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Sala',
      datacenter: 'Datacenter',
      zone: 'Zona',
      region: 'Região'
    },
    cablingTitle: 'Cablagem',
    cablingSubtitle: 'A que porta do switch está ligada cada interface — a declaração vive no nó (Annex O.9)',
    cablingHint: 'Um cabo por NIC, um cabo por porta em toda a frota (a API recusa nomeando o titular). Cablar para uma porta membro de um LAGG é legal — é o caso bond: a derivação futura irá renderizá-lo como LACP.',
    cablingInterface: 'Interface',
    cablingNotCabled: '— não ligada —',
    cablingNoInterfaces: 'Nenhuma interface de rede observada',
    disksTitle: 'Discos',
    disksSubtitle: 'Dispositivos de blocos observados — um varrimento por passagem de reconciliação; marque aqui os discos utilizáveis como OSDs Ceph (N.15: a elegibilidade é explícita)',
    colDataDisk: 'Disco de dados',
    dataDisksHint: 'Assinalar um dispositivo declara-o utilizável como OSD; o número de série é o seu pin de identidade — copiado do hardware quando o disco o reporta, cunhado (tvirt-…) caso contrário. O dialog de registo Ceph oferece apenas os discos declarados.',
    diskDeclaredSerial: 'declarado',
    diskNotObserved: 'declarado mas não observado — volte a ligar o dispositivo ou retire a marca',
    noDisks: 'Nenhum dispositivo de blocos observado ainda',
    colSerial: 'N.º de série',
    colModel: 'Modelo',
    colSize: 'Tamanho (GiB)',
    colDiskType: 'Tipo',
    colInUse: 'Em uso',
    colObservedAt: 'Observado',
    diskInUse: 'em uso',
    diskFree: 'livre',
    diskMounted: 'montado',
    diskPartitions: 'partições',
    passthroughTitle: 'Dispositivos passthrough',
    passthroughSubtitle: 'GPUs e dispositivos USB observados — marque aqui o que o TVirt pode passar às VMs; a marcação regista a identidade do dispositivo (ronda U1+G1)',
    passthroughHint: 'A marcação regista o dispositivo (um id estável — o alvo de tags e requisitos de classe). Uma GPU marcada tem o grupo IOMMU INTEIRO ligado ao vfio-pci em bloco — deixa imediatamente o host; desmarcar volta a ligar o driver nativo. Para USB existem ambos os modelos ratificados: por dispositivo (vendor+produto, onde quer que esteja ligado) e por porta física (a VM recebe o que quer que lá esteja metido). O USB não faz bind na marcação — o attach acontece no runtime da VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Utilizável pelo TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Endereço PCI',
    colDriver: 'Driver',
    colVerdict: 'Veredicto',
    gpuEligible: 'Elegível',
    gpuIneligible: 'Não elegível',
    gpuReason: {
      'no-iommu': 'IOMMU não ativo no host',
      'group-spans-slots': 'grupo IOMMU não isolado: estende-se por outros slots',
      'multiple-display': 'grupo IOMMU não isolado: mais do que uma função de vídeo',
      'foreign-function': 'grupo IOMMU não isolado: contém uma função estranha'
    },
    vfioNotReady: 'O IOMMU não está ativo neste host: nenhuma GPU é elegível enquanto a plataforma host não o ativar (ISO OEM) — o TVirt nunca retoca os kernel args em runtime.',
    vfioMissingKernelArg: 'O IOMMU não está ativo neste host: o firmware reporta VT-d/AMD-Vi (tabela ACPI DMAR/IVRS presente) mas falta o kernel arg — adicione intel_iommu=on (Intel) ou retire amd_iommu=off (AMD) da command line do kernel e reinicie. O TVirt nunca retoca os kernel args em runtime.',
    vfioFirmwareDisabled: 'O IOMMU não está ativo neste host: o VT-d/AMD-Vi está desativado no firmware (nenhuma tabela ACPI DMAR/IVRS) ou o CPU não o suporta — ative-o no setup do firmware, nenhum kernel arg o pode ligar. O TVirt nunca retoca o host em runtime.',
    gpuBindError: 'Bind vfio-pci falhou em {address}: {error}',
    firewallBridgesTitle: 'Firewall em bridges não geridas',
    firewallBridgesSubtitle: 'As bridges construídas à mão neste nó cujo setup consente as chains de firewall renderizadas pelo TVirt nas NICs de convidado ligadas',
    firewallBridgesHint: 'O TVirt nunca toca na bridge alheia — a chain ancora no tap/veth, que é sempre do TVirt. A lista é um gate de consentimento: default-deny e anti-spoof podem partir o que um setup manual espera, por isso uma NIC com firewall numa bridge não gerida NÃO listada aqui é recusada com um erro falante.',
    firewallBridgesEmpty: 'Nenhuma bridge não gerida consente as chains de firewall renderizadas pelo TVirt neste nó.',
    firewallBridgeAdd: 'Adicionar bridge',
    firewallBridgeInvalid: 'Não é um nome de interface Linux (1-15 caracteres, sem slash nem espaços)',
    firewallBridgeDuplicate: 'Nome já na lista',
    colMarkDevice: 'Por dispositivo',
    colMarkPort: 'Por porta',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Porta',
    passthroughOrphan: 'órfão — registado mas já não detetado: volte a ligá-lo ou desmarque-o',
    noGpus: 'Nenhuma GPU observada ainda',
    noUsb: 'Nenhum dispositivo USB observado ainda',
    networkGeneration: 'Geração de rede',
    applied: 'Aplicada',
    converged: 'alinhado',
    behind: 'atrasado — {m} / {n}',
    notConfigured: 'não configurado',
    rollbackBody: 'A aplicação da geração {gen} falhou: {error}',
    rolledBackChip: 'rollback executado',
    nicsTitle: 'NICs',
    nicsSubtitle: 'O registo das NICs geridas — registar É a declaração de gestão: uma NIC registada sem configuração não é tocada (clear-if declara-a explicitamente limpa), um dispositivo não registado nunca é tocado',
    addNic: 'Registar NIC',
    addNicTitle: 'Registar NIC (add-nic)',
    delNic: 'Terminar gestão',
    delNicTitle: 'Terminar gestão (del-nic)',
    delNicConfirm: 'A gestão de {name} termina: a entrada do registo e a sua configuração são eliminadas e o perfil TVirt removido — o dispositivo fica tal como o Linux o tem.',
    nicName: 'Nome do dispositivo',
    nicMac: 'Endereço MAC permanente',
    nicMacHint: 'o MAC de hardware permanente — a identidade estável fixada pelo TVirt Server Installer',
    colObserved: 'Observada',
    nicObserved: 'observada',
    nicNotObserved: 'não observada',
    nicMacMismatch: 'MAC divergente — observado {mac}',
    noNics: 'Nenhuma NIC registada — registe um dispositivo para começar a geri-lo',
    noManagedDevices: 'Nenhum dispositivo gerido — registe primeiro uma NIC, tudo se constrói sobre o registo',
    inventoryTitle: 'Dispositivos observados',
    inventorySubtitle: 'Atualizados a cada passagem de reconciliação pelo worker do nó — a validação verifica os nomes dos dispositivos contra este inventário',
    colDevice: 'Dispositivo',
    colType: 'Tipo',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Velocidade',
    colTopology: 'Topologia',
    colMtu: 'MTU',
    colAddresses: 'Endereços',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP não agrega',
    noInventory: 'Nenhum dispositivo reportado até agora',
    interfacesTitle: 'Interfaces',
    interfacesSubtitle: 'Configuração L3 das NICs registadas e dos dispositivos lógicos declarados — set-if substitui o bloco inteiro, edit-if retoca as propriedades, clear-if esvazia-o (limpeza explícita)',
    colConfig: 'Configuração desejada',
    clean: 'limpa',
    setIf: 'Editar endereçamento',
    setIfTitle: 'Editar endereçamento (set-if)',
    editIf: 'Editar propriedades',
    editIfTitle: 'Editar propriedades (edit-if)',
    clearIf: 'Esvaziar configuração',
    clearIfTitle: 'Esvaziar configuração (clear-if)',
    clearIfConfirm: 'A configuração da interface é esvaziada. Uma interface limpa é o pré-requisito para a subordinar como membro de bond/bridge ou parent de VLAN.',
    ip4Mode: 'Modo IPv4',
    ip6Mode: 'Modo IPv6',
    modeUnconfigured: 'Não configurada',
    modeStatic: 'Estática',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Endereços IPv4',
    ip6Addresses: 'Endereços IPv6',
    addressesHint: 'CIDR, separados por vírgula',
    gw4: 'Gateway IPv4',
    gw6: 'Gateway IPv6',
    dns: 'Servidores DNS',
    dnsHint: 'separados por vírgula — vazio limpa o DNS (set-if substitui o bloco)',
    routes4: 'Rotas estáticas IPv4',
    routes6: 'Rotas estáticas IPv6',
    routeTo: 'Destino (CIDR)',
    routeVia: 'Via',
    addRoute: 'Adicionar rota',
    routesChip: 'rotas',
    mtu: 'MTU',
    mtuHint: 'vazio = default do driver',
    vlansTitle: 'VLANs',
    addVlan: 'Adicionar VLAN',
    addVlanTitle: 'Adicionar VLAN (add-vlan)',
    delVlanTitle: 'Eliminar VLAN (del-vlan)',
    vlanParent: 'Interface parent',
    vlanId: 'ID VLAN',
    vlanPreview: 'Nome do dispositivo',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Nenhuma VLAN declarada',
    bondsTitle: 'Bonds',
    addBond: 'Adicionar bond',
    addBondTitle: 'Adicionar bond (add-bond)',
    editBondTitle: 'Editar bond',
    editBond: 'Guardar bond',
    delBondTitle: 'Eliminar bond (del-bond)',
    bondName: 'Nome do bond',
    members: 'Membros',
    membersHint: 'os membros têm de ser interfaces limpas (sem configuração L3)',
    bondMode: 'Modo',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Membro primário',
    rate: 'Rate LACP',
    hash: 'Política de hash em transmissão',
    colMembers: 'Membros',
    colMode: 'Modo',
    noBonds: 'Nenhum bond declarado',
    bridgesTitle: 'Bridges',
    addBridge: 'Adicionar bridge',
    addBridgeTitle: 'Adicionar bridge (add-bridge)',
    editBridgeTitle: 'Editar bridge',
    editBridge: 'Guardar bridge',
    delBridgeTitle: 'Eliminar bridge (del-bridge)',
    bridgeName: 'Nome da bridge',
    stp: 'STP',
    stpOn: 'STP ativo',
    stpOff: 'STP desligado',
    colStp: 'STP',
    noBridges: 'Nenhuma bridge declarada',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Definir hostname',
    setHostnameTitle: 'Definir hostname (set-hostname)',
    hostnameHint: 'Apenas identidade do OS — o nome do nó no cluster não é tocado',
    notSet: 'não definido',
    staticHostsTitle: 'Entradas de host estáticas',
    addStaticHost: 'Adicionar entrada',
    addStaticHostTitle: 'Adicionar entrada de host estática',
    delStaticHostTitle: 'Eliminar entrada de host estática',
    hostIp: 'Endereço IP',
    hostNames: 'Nomes',
    hostNamesHint: 'separados por vírgula ou espaço',
    colIp: 'IP',
    colNames: 'Nomes',
    noStaticHosts: 'Nenhuma entrada de host estática',
    delConfirm: 'Remoção de {name} do documento desejado — o worker do nó converge com um checkpoint do NetworkManager e rollback automático.',
    remove: 'Remover',
    opError: 'A operação de rede foi recusada'
  }
}
